import { styled } from '@linaria/react';
import { fonts, primitives, semantic, size, space } from '../../theme/tokens';

export const CardButton = styled.button`
  display: flex;
  align-items: flex-start;
  gap: ${space['space-600']};
  width: 100%;
  padding: ${space['space-800']};
  background: ${semantic.bg.canvas};
  border: ${size.stroke['stroke-default']} solid ${semantic.border.default};
  border-radius: ${size.radius['radius-xl']};
  cursor: pointer;
  text-align: left;
  font-family: ${fonts.body};
  color: ${semantic.text.primary};
  transition: background-color 0.15s ease, border-color 0.15s ease;

  &:focus-visible {
    outline: ${size.stroke['stroke-thick']} solid ${semantic.border.selected};
    outline-offset: ${space['space-050']};
  }

  &:hover:not(:disabled) {
    background: ${semantic.bg.surfaceSubtle};
    border-color: transparent;
  }
`;

export const IconSlot = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: ${primitives.size['size-1600']};
  height: ${primitives.size['size-1200']};
  padding: ${space['space-300']} ${space['space-500']};
  background: ${semantic.bg.surfaceSubtle};
  border-radius: ${size.radius['radius-full']};
  color: ${semantic.text.primary};
  font-family: ${fonts.body};
  font-size: ${fonts.size.sm};
  font-weight: ${fonts.weight.medium};
  flex-shrink: 0;
`;

export const TextGroup = styled.span`
  display: flex;
  flex-direction: column;
  gap: ${space['space-050']};
  flex: 1;
  min-width: 0;
`;

export const Title = styled.span`
  font-family: ${fonts.body};
  font-size: ${fonts.size.base};
  font-weight: ${fonts.weight.normal};
  line-height: ${primitives.typography.lineHeight.normal};
  color: ${semantic.text.primary};
`;

export const Description = styled.span`
  font-family: ${fonts.body};
  font-size: ${fonts.size.base};
  font-weight: ${fonts.weight.normal};
  line-height: ${primitives.typography.lineHeight.normal};
  color: ${semantic.text.secondary};
`;
